
module part {
  'use strict';

  export class PartCtrl {


    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$scope',
      '$timeout',
      '$filter',
      '$element',
      'partService', 
      'anchorNavService',
      'localStorageService', 
      'pageMetaService',
    ];

    // dependencies are injected via AngularJS $injector
    // controller's name is registered in Application.ts and specified from ng-controller attribute in index.html
    constructor(
      private $scope: IPartControllerScope,
      private $timeout: ng.ITimeoutService,
      private $filter: misc.IAdvancedNumberFilter,
      private $element :  ng.IRootElementService,
      private partService: IPartService,
      private anchorNavService: navigation.IAnchorNavService,
      private localStorageService: any,
      private pageMetaService: navigation.IPageMetaService
      ) {
      
      // 'vm' stands for 'view model'. We're adding a reference to the controller to the scope
      // for its methods to be accessible from view / HTML
      $scope.vm = this;
      $scope.meta = pageMetaService.getPageMeta;

      if ($scope.meta('hl') == 'D') {
        $scope.topLevelNav =  [
          { 'id' : 1, 'name' : 'Artikelreferenz' }
          , { 'id' : 2, 'name' : 'Ersatzteilliste' }
        ];
      } else {
        $scope.topLevelNav =  [
          { 'id' : 1, 'name' : 'Parts Reference' }
          , { 'id' : 2, 'name' : 'Spare Parts' }
        ];
      }

      var filterGroups = (scope : IPartControllerScope, cat : ArtikelReferenzKategorie) =>  {
        scope.groups = [];
        if (!cat) return;
        cat.Gruppen.forEach((group) => {
          var found = scope.selectedReferences.filter((reference) =>  {
            return reference.GruppeNummer== group.Nummer; 
          });
          if (found.length > 0) scope.groups.push(group);
        });
      }

      
      $scope.$watch('partsearch', (newVal : string, oldval : string, scope : IPartControllerScope) => {
        if (newVal != oldval) {
          anchorNavService.search(newVal ? {"partid" : newVal} : {"partid" : null});          
        }
      });

      var queryPartId = anchorNavService.getQueryValue('partid');
      if (queryPartId !== null && typeof queryPartId !== 'boolean' ) { 
        this.partService.openDialog(queryPartId, $scope);
      };

      //update groups on cat select
      $scope.$watch('selectedPartsReferenceCat', (newVal : ArtikelReferenzKategorie, oldval : ArtikelReferenzKategorie, scope : IPartControllerScope) => {
        if (!scope.selectedReferences) { 
          if (scope.selectedPartsReferenceCat) {
            scope.groups = scope.selectedPartsReferenceCat.Gruppen;
            scope.selectedPartsReferenceGroup = scope.groups[0];
          }
          return;
        }
        filterGroups(scope, newVal);        
      });

      var setData = (data : ServiceData)  => {
        $scope.data = data;
        $scope.categories = data.PartsReference.Kategorien;
        $scope.referenceGroups = data.ReferenceGroup; 

        $scope.selectedPartsReferenceCat = $scope.categories[0];
        $scope.selectedReferenceGroup = $scope.referenceGroups[0];

        $scope.replacementParts = [];
        data.ReferenceGroup.forEach((group) => {
          group.Part2Product.forEach((p2p) => {
            $scope.replacementParts.push(p2p);
          });
        });

        if (anchorNavService.getQueryValue("PartId") && typeof anchorNavService.getQueryValue("PartId") !== 'boolean') { 
          $scope.partsearch = anchorNavService.getQueryValue("PartId");
        };
      };

      partService.loadPartsByProduct(pglob.RouteData.RouteEntry.RouteParameterStack).then((data: ServiceData) =>  {
        setData(data);
      });
      partService.loadAvailabilityByProduct(pglob.RouteData.RouteEntry.RouteParameterStack).then(( data: AvailabilityServiceData ) =>  {
        $scope.availability = data;
      });

      anchorNavService.subscribeOnLocationChanged($scope, (event: ng.IAngularEvent, re: IRouteEntry) => {
        partService.loadPartsByProduct(re.RouteParameterStack).then(( data: ServiceData ) => {
          setData(data);
        });
        partService.loadAvailabilityByProduct(pglob.RouteData.RouteEntry.RouteParameterStack).then(( data: AvailabilityServiceData ) => {
          $scope.availability = data;
        });
      });


      
      $scope.$watch('settings.showList', (newVal : boolean, oldval : boolean, scope : IPartControllerScope) => {
        if (typeof newVal !== 'undefined' && newVal != oldval) this.localStorageService.set('PartCtrl-Settings', this.$scope.settings);
      });
            
      $scope.settings = this.localStorageService.get('PartCtrl-Settings') || new PartCtrlSettings(false);

    }

  }

}